export default "__VITE_ASSET___h8OpTOj__"